/**
 * License Intelligence SAP Unit Consumption Trend Mock Data
 *
 * Mock data for the unit consumption trend API endpoint.
 * In production, this data will come from:
 * GET /ECMv6/api/sodms/license-intelligence/v1/sap/overview/unit-consumption-trend
 */

import type { UnitConsumptionTrendData } from '../types';

interface UnitConsumptionTrendResponse {
  data: UnitConsumptionTrendData;
  status: number;
  message: string;
}

export const LICENSE_INTELLIGENCE_UNIT_CONSUMPTION_TREND_DATA: UnitConsumptionTrendResponse =
  {
    data: {
      contractedUnit: 4200.0,
      dataPoints: [
        { month: "Jun '25", value: 3200.0 },
        { month: "Jul '25", value: 3350.0 },
        { month: "Aug '25", value: 3400.0 },
        { month: "Sep '25", value: 3500.0 },
        { month: "Oct '25", value: 3550.0 },
        { month: "Nov '25", value: 3600.0 },
        { month: "Dec '25", value: 3700.0 },
        { month: "Jan '26", value: 3750.0 },
        { month: "Feb '26", value: 3800.0 },
        { month: "Mar '26", value: 3750.0 },
        { month: "Apr '26", value: 3820.0 },
        { month: "May '26", value: 3847.0 },
      ],
      monthsAvailable: 12,
    },
    status: 200,
    message: 'Unit consumption trend data retrieved successfully',
  };

export default LICENSE_INTELLIGENCE_UNIT_CONSUMPTION_TREND_DATA;
